import { ReactNode } from "react"

import Header from "../Header"

import styles from "./styles.module.scss"

type LayoutProps = {
  height: number | string
  children: ReactNode
}

const PageLayout = ({ children, height }: LayoutProps) => {
  return (
    <main className={styles.container} style={{ height: typeof height === "number" ? `${height}px` : height }}>
      <Header />
      <div className={styles.contentContainer}>{children}</div>
    </main>
  )
}

export default PageLayout
